module.exports = __webpack_public_path__ + "img/list10.a77a07f5.jpg";